import { CraComment } from "../models/CraComment";

export enum CommentFilterOption {
  All = "all",
  Resolved = "resolved",
  Unresolved = "unresolved",
}

export const isCraWayComment = (comment: CraComment) => !comment.craNodeId;

export const isNodeComment = (comment: CraComment, craNodeId: string) =>
  comment.craNodeId === craNodeId;

export const isMainThreadResolved = (
  allComments: CraComment[],
  actualComment: CraComment
) => {
  if (!actualComment.mainThreadId) return actualComment.resolved;
  return allComments.find((comm) => comm.id === actualComment.mainThreadId)
    ?.resolved;
};

export const countThreadsAndReplies = (comments: CraComment[]) =>
  comments.reduce((total, comment) => total + comment.replies.length + 1, 0);

export const filterCommentByOption = (
  comment: CraComment,
  option: CommentFilterOption
) => {
  switch (option) {
    case CommentFilterOption.All:
      return true;
    case CommentFilterOption.Resolved:
      return comment.resolved;
    case CommentFilterOption.Unresolved:
      return !comment.resolved;
    default:
      return false;
  }
};
